import { Component, input } from '@angular/core';

export type SpinnerSize = 'small' | 'medium' | 'large';
export type SpinnerColor = 'primary' | 'accent' | 'warn' | 'white';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-spinner',
  standalone: true,
  template: `
    <div class="spinner-container" [class.fullscreen]="fullscreen()">
      <div [class]="'spinner ' + size() + ' ' + color()" [style.width.px]="diameter()" [style.height.px]="diameter()">
        <svg viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      @if (message()) {
        <div class="message">
          {{ message() }}
        </div>
      }
    </div>
  `,
  styles: `
    .spinner-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
    }

    .spinner-container.fullscreen {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(255, 255, 255, 0.8);
      z-index: 9999;
    }

    .spinner {
      animation: rotate 2s linear infinite;
    }

    .spinner.small {
      width: 24px;
      height: 24px;
    }

    .spinner.medium {
      width: 40px;
      height: 40px;
    }

    .spinner.large {
      width: 60px;
      height: 60px;
    }

    .spinner.primary {
      color: #1976d2;
    }

    .spinner.accent {
      color: #ff4081;
    }

    .spinner.warn {
      color: #f44336;
    }

    .spinner.white {
      color: #ffffff;
    }

    .spinner svg {
      width: 100%;
      height: 100%;
    }

    .path {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }

    .message {
      color: #666;
      font-size: 14px;
      text-align: center;
    }

    @keyframes rotate {
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes dash {
      0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
      }
    }
  `,
})
export class SpinnerComponent {
  readonly diameter = input(40);
  readonly size = input<SpinnerSize>('medium');
  readonly color = input<SpinnerColor>('primary');
  readonly message = input<string>();
  readonly fullscreen = input(false);
}
